/**
 * Wer angemeldet ist — und wie man es beendet.
 *
 * **Tritt an die Stelle der Personenwahl, nicht daneben.** Der Umschalter des
 * Demonstrationsstands neben einer echten Anmeldung wäre die gefährlichste
 * Fassung: Er sähe aus wie ein Rollenwechsel und wäre keiner, denn die Rollen
 * kommen dann aus dem Token. Wer damit die Sicht wechselt, glaubt eine
 * Rechteprüfung zu sehen, die es nicht gibt.
 *
 * **Der Name steht da, weil er dastehen muss.** `07` §7.2 unterscheidet sechs
 * Rollen mit verschiedenen Sichten; wer nicht sieht, als wer er arbeitet,
 * hält die Sicht für die einzige. Im Demonstrationsstand galt dasselbe
 * Argument für die sichtbare Wahl.
 */

import type { Angemeldet } from "./anmeldung.js";

export function AngemeldetAls({
  wer,
  beiAbmelden,
}: {
  readonly wer: Angemeldet;
  readonly beiAbmelden: () => void;
}) {
  /*
   * **Der Anzeigename kann fehlen.** Keycloak liefert `name` nur, wenn Vor-
   * und Nachname gepflegt sind; `preferred_username` gibt es immer. Ein
   * leerer Platz in der Kopfzeile sähe aus wie ein Fehler der Anwendung.
   */
  const anzeige = wer.name || wer.benutzername || "angemeldet";

  return (
    <span className="angemeldet" data-angemeldet={wer.benutzername || "ja"}>
      <span className="angemeldet__name">{anzeige}</span>
      <button type="button" onClick={beiAbmelden} className="angemeldet__ab">
        Abmelden
      </button>
    </span>
  );
}
